import { Routes } from '@angular/router';
import { PageNotFoundComponent } from './core/pages/page-not-found/page-not-found.component';
import { RouteGuardService } from './core/guards/route-guard/route-guard.service';
import { AuthGuard } from './core/guards/auth.guard';
import { HeaderComponent } from './core/components/header/header.component';

export const routes: Routes = [
  {
    path: 'help/gprmateriaal',
    loadChildren: () => import('./help/help.module').then(m => m.HelpModule)
  },
  {
    path: 'faq/gprmateriaal',
    loadChildren: () => import('./faq/faq.module').then(m => m.FaqModule)
  },
  {
    path: 'faq/gprgebouw',
    loadChildren: () => import('./faq/faq.module').then(m => m.FaqModule)
  },
  {
    path: 'release-notes',
    loadChildren: () => import('./release-notes/release-notes.module').then(m => m.ReleaseNotesModule)
  },
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
    canMatch: [AuthGuard, RouteGuardService]
  },
  {
    path: '',
    component: HeaderComponent,
    canActivate: [RouteGuardService],
    canActivateChild: [AuthGuard],
    children: [
      {
        path: 'dashboard',
        loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule)
      }
    ]
  },
  {
    path: '**',
    component: PageNotFoundComponent,
    canActivate: [RouteGuardService]
  }
];
